import React from "react";
import cx from "classnames";

const LoadingOverlay = ({ title, message }) => (
  <div className={cx("overlay", { "overlay--loading": Boolean(title) })}>
    <div className="overlay__content">
      {Boolean(title) && <h3 className="overlay__title">{title}</h3>}
      <div className="spinner">
        <div className="double-bounce1" />
        <div className="double-bounce2" />
      </div>
      {Boolean(message) && (
        <div className="overlay__alert alert alert--warning">{message}</div>
      )}
    </div>
  </div>
);

export default LoadingOverlay;
